document.querySelectorAll("slider-component .product-grid").forEach(function(ele) {
    let pos = { left: 0, x: 0 };
    let moving = 0;

    const mouseDownHandler = function (e) {
       // e.preventDefault();
       // e.stopPropagation();
        pos = {
            // The current scroll
            left: ele.scrollLeft,
            // Get the current mouse position
            x: e.clientX,
        };
        moving = 1;
    };

    const mouseMoveHandler = function (e) {
        if(moving != 1) {
            return;
        }
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;

        // Scroll the element
        ele.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function () {
        moving = 0;
    };

    // Attach the `mousedown` event handler
    ele.addEventListener('mousedown', mouseDownHandler);
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
});

document.querySelectorAll(".card-product1 .btn-next").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        var sel_ind = parseInt(obj.parentElement.getAttribute("data-selected_index"));
        var card__media = obj.closest(".card").querySelector(".card__media");
        var card_count = card__media.querySelectorAll(".media").length;
        if(sel_ind >= card_count) {
            return;
        }

        obj.classList.remove("disabled");
        obj.parentElement.querySelector(".btn-prev").classList.remove("disabled");
        var card_width = card__media.querySelector(".media").offsetWidth;
        var scroll_amount = card_width * sel_ind;
        card__media.scroll({
          left: scroll_amount,
          behavior: 'smooth'
        });

        sel_ind ++;
        if(sel_ind >= card_count) {
            obj.classList.add("disabled");
        }
        obj.parentElement.setAttribute("data-selected_index", sel_ind);
    });
});

document.querySelectorAll(".card-product1 .btn-prev").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        var sel_ind = parseInt(obj.parentElement.getAttribute("data-selected_index"));
        var card__media = obj.closest(".card").querySelector(".card__media");
        var card_count = card__media.querySelectorAll(".media").length;
        if(sel_ind <= 1) {
            return;
        }

        obj.classList.remove("disabled");
        obj.parentElement.querySelector(".btn-next").classList.remove("disabled");
        sel_ind --;

        var card_width = card__media.querySelector(".media").offsetWidth;
        var scroll_amount = card_width * (sel_ind - 1);
        card__media.scroll({
          left: scroll_amount,
          behavior: 'smooth'
        });
        if(sel_ind <= 1) {
            obj.classList.add("disabled");
        }
        obj.parentElement.setAttribute("data-selected_index", sel_ind);
    });
});

// Description trigger on each BAB product card now opens a rich product
// quick-view modal (rendered inline per card by card-product_for_bundle.liquid)
// instead of the plain-text .popup-description-wrapper. If a trigger doesn't
// carry the new data-bab-modal-target attribute we silently fall back to the
// legacy text popup so nothing regresses for other pages that still ship it.
document.querySelectorAll(".description_popup-trigger .btn-description").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        e.preventDefault();
        var targetId = e.currentTarget.getAttribute("data-bab-modal-target");
        if (targetId) {
            var modal = document.getElementById(targetId);
            if (modal) {
                modal.hidden = false;
                document.body.style.overflow = "hidden";
                return;
            }
        }
        // Legacy fallback — pages/snippets without the new modal keep the text popup.
        var descEl = document.querySelector(".popup-description .description-content");
        var wrapEl = document.querySelector(".popup-description-wrapper");
        if (!descEl || !wrapEl) return;
        descEl.innerHTML = "";
        wrapEl.classList.remove("hide");
        var source = e.currentTarget.parentNode.querySelector("[data-product-description]");
        if (source) descEl.innerHTML = source.innerHTML;
    });
});

document.querySelectorAll(".popup-description-wrapper .btn-close").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        obj.closest(".popup-description-wrapper").classList.add("hide");
    });
});

// New BAB card modal — open/close, thumbnail image swap, "Add to bundle"
// mirror the card's own .atc so the shopper can add straight from the modal.
(function () {
    function closeBabModal(modal) {
        modal.hidden = true;
        document.body.style.overflow = "";
    }

    document.querySelectorAll("[data-bab-modal]").forEach(function (modal) {
        // Backdrop click
        modal.addEventListener("click", function (e) {
            if (e.target === modal) closeBabModal(modal);
        });
        // Close button
        var closeBtn = modal.querySelector("[data-bab-modal-close]");
        if (closeBtn) closeBtn.addEventListener("click", function () { closeBabModal(modal); });

        // Escape key
        modal.addEventListener("keydown", function (e) {
            if (e.key === "Escape") closeBabModal(modal);
        });

        // Thumbnail image swap
        var mainImg = modal.querySelector("[data-bab-modal-main-img]");
        modal.querySelectorAll("[data-bab-modal-thumb]").forEach(function (thumb) {
            thumb.addEventListener("click", function () {
                var full = thumb.getAttribute("data-full-src");
                if (mainImg && full) mainImg.src = full;
                modal.querySelectorAll("[data-bab-modal-thumb]").forEach(function (t) {
                    t.classList.remove("is-active");
                });
                thumb.classList.add("is-active");
            });
        });

        // Add-to-bundle mirrors the card's .atc so the existing BAB add flow
        // (tier logic, exclusivity rule, bubble render) all fires unchanged.
        var atc = modal.querySelector("[data-bab-modal-atc]");
        if (atc) {
            atc.addEventListener("click", function () {
                var variantId = atc.getAttribute("data-target-atc-id");
                if (!variantId) return;
                var card = modal.closest(".card-wrapper");
                var cardAtc = card ? card.querySelector(".atc") : null;
                if (!cardAtc) {
                    // Fallback: try to find any .atc[id="<variantId>"] on the page
                    cardAtc = document.querySelector('.atc[id="' + variantId + '"]');
                }
                if (cardAtc) {
                    cardAtc.click();
                    closeBabModal(modal);
                }
            });
        }
    });

    // Global escape handler (in case the modal itself doesn't have focus)
    document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") return;
        document.querySelectorAll("[data-bab-modal]").forEach(function (modal) {
            if (!modal.hidden) closeBabModal(modal);
        });
    });
})();

document.querySelectorAll("select[name='options[Flavor]']").forEach(function(obj) {
  obj.addEventListener("change", function(e) {



    document.querySelectorAll(".thumbnail-list__item").forEach(function(obj1) {
      var alt = obj1.getAttribute("data-alt");


      if(obj.value == alt || !alt || alt == '') {
        obj1.classList.remove("hide");
      }
      else {
        obj1.classList.add("hide");
      }
    });

    document.querySelectorAll(".product__media-item").forEach(function(obj2) {
      var alt = obj2.getAttribute("data-alt");


      if(obj.value == alt || !alt || alt == '') {
        obj2.classList.remove("hide");
      }
      else {
        obj2.classList.add("hide");
      }
    });
  });
});

if(document.querySelector("select[name='options[Flavor]']")) {
  var evt = document.createEvent("HTMLEvents");
  evt.initEvent("change", false, true);
  document.querySelector("select[name='options[Flavor]']").dispatchEvent(evt);
}

document.querySelectorAll(".btn-stack").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        e.preventDefault();
        obj.parentElement.querySelector(".modal-stack").classList.remove("hide");
    });
});

document.querySelectorAll(".modal-stack").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        if(!(e.target.classList.contains("modal-inner") || e.target.closest(".modal-inner"))) {
            obj.classList.add("hide");
        }
    });
});

document.querySelectorAll(".btn-bundle").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    // e.preventDefault();

    // var link = obj.getAttribute("href");
    // var id = obj.closest(".product__info-wrapper").querySelector("input[name=id]").value;
    // link += "&id=" + id;

    // window.location.href = link;
  });
});

document.querySelectorAll(".product-card-bundle #variant-select").forEach(function(obj) {
  obj.addEventListener("change", function(e) {
    var selected_opt = obj.options[obj.selectedIndex];
    var card = obj.closest(".card");
    var price = "$" + (parseFloat(selected_opt.getAttribute("data-price")) / 100).toFixed(2);
    card.querySelector(".price-item").textContent = price;
    card.querySelector(".atc").setAttribute("data-product", selected_opt.getAttribute("data-price"));
  });
});

document.querySelectorAll('.btn-shop').forEach(function(shopButton) {
  if(!window.location.pathname.includes('apparel')) {
    shopButton.addEventListener('click', function(e) {
        e.preventDefault();
        const quickAddButton = shopButton.closest('.card').querySelector('modal-opener button');
        if (quickAddButton) {
            quickAddButton.click();
        }
        const productFormButton = shopButton.closest('.card').querySelector('product-form button');
        if (productFormButton) {
            productFormButton.click();
        }
    });
  }
});